import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Stages from "@/pages/Stages";
import StageDetail from "@/pages/StageDetail";
import MyBets from "@/pages/MyBets";
import Leaderboard from "@/pages/Leaderboard";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Profile from "@/pages/Profile";
import AuthCallback from "@/pages/AuthCallback";
import LiveTracker from "@/pages/LiveTracker";
import JoinLeague from "@/pages/JoinLeague";
import CGU from "@/pages/CGU";
import Confidentialite from "@/pages/Confidentialite";
import MentionsLegales from "@/pages/MentionsLegales";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/join/:code" element={<JoinLeague />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/contact" element={<Contact />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Home />} />
              <Route path="/etapes" element={<Stages />} />
              <Route path="/etapes/:id" element={<StageDetail />} />
              <Route path="/mes-paris" element={<MyBets />} />
              <Route path="/classement" element={<Leaderboard />} />
              <Route path="/live" element={<LiveTracker />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profil" element={<Profile />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Admin />
                  </ProtectedRoute>
                }
              />
            </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
